var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreatBritain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "85.5 0 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.046784 0 0 .049795 85.5 0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h513v341.3h-513z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.7 230 201.3 111.3v-31.5l-143.7-79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200.3,111.3 0,0 v 31.5 l 143.7,79.8 z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.046784 0 0 .049795 85.5 0)",
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m393.8 230 119.2 65.7v-65.7zm-82.1 0 201.3 111.3v-31.5l-143.7-79.8zm146.9 111.3-147-81.7v81.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.3 230-90.3 50.2v-50.2zm110 14.2v97.2h-174.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118.2,111.3 0,45.6 v 65.7 z m 82.1,0 L 0,0 v 31.5 l 143.7,79.8 z M 53.4,0 200.4,81.7 V 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.7 111.3 91.3-50.2v50.2zm-110-14.2v-97.1h174.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.046784 0 0 .049795 85.5 0)",
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288 0h-64v138.7h-224v64h224v138.7h64v-138.7h224v-64h-224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.7 230 201.3 111.3v-31.5l-143.7-79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.7 230-143.7 79.9v31.5l200.3-111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 200.3,111.3 0,0 v 31.5 l 143.7,79.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 368.3,111.3 513,31.5 V 0 L 311.7,111.3 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreatBritain);
export default __webpack_public_path__ + "static/media/great-britain.9e3048ecd64a2bae68f631c1a44798b9.svg";
export { ForwardRef as ReactComponent };